<script>

/**
 * Section: Content Pods
 * ------------------------------------------------------------------------------
 * - Placeholder for Webpack processing.
 */
export default {
  name: 'ContentPods',
}
</script>
